module.exports = __webpack_public_path__ + "static/media/IMG_6603 1.649f3a6a.jpg";